import {GeneralRedirect, IRoutesProvider } from 'Shared/Routes';
import { sharedRoutes } from 'Shared/routes/SharedRoutes';
import { lazy, onMount } from 'solid-js';


export class AdminRoutes implements IRoutesProvider
{
	routes()
	{
		return ([
			{
				path: '/',
				component: () => <GeneralRedirect url='/login' />
			},
			{
				path: '/login',
				component: lazy(() => import('Shared/users/LoginPage')),
			},
			...sharedRoutes(),

			{
				path: '/',
				component: lazy(() => import('Shared/admin/AdminWrap')),

				children: [
					{
						path: '/dashboard',
						component: lazy(() => import('Shared/admin/DashboardPage')),
					},
					{
						path: '/sites',
						component: lazy(() => import('Shared/admin/SitesPage')),
					},
					{
						path: '/site/:id',
						component: lazy(() => import('Shared/admin/SitePage')),
					},
					{
						path: '/posters',
						component: lazy(() => import('Shared/admin/PostersPage')),
					},
					{
						path: '/posterTheme/:id',
						component: lazy(() => import('Shared/admin/PosterThemePage')),
					},
					{
						path: '/textHooks',
						component: lazy(() => import('Shared/admin/TextHooksPage').then(m => ({default: m.TextHooksPage}))),
					},
				]
			},
			{
				path: '/poster',
				component: lazy(() => import('Shared/admin/PosterWrap')),
				children: [
					{
						path: '/:id',
						component: lazy(() => import('Shared/admin/PosterDesignPage')),
					},
				]
			},
			{
		
				path: '/*',
				component: PageNotFoundPage,
				//NOTE Solid Start has a way to do this built in. Doesn't matter enough to bother with for the moment.
//				code: 400
			}
		]);
	}

//TODO maybe trim trailing / from all...
}

function PageNotFoundPage()
{
	onMount(() => document.body.style.opacity = '1');

	return (
		<p>
			Sorry, no such page.
		</p>
	);
}

